"use strict";

angular.module("app"). directive("tchWaiter", function() {

	var elemBackup;

	return {
		restrict: "A",
		scope: {
			watcher: "=tchWaiter"
		},
		link: function(scope, elem) {
			scope.$watch("watcher", function(value) {
				if (value) {
					elemBackup = elem.html();
					elem.html("<img src=\"assets/img/waiter.gif\" />");

				} else {
					elem.html(elemBackup);
				}
			});
		}
	};
});